import 'styles/Gallery.less'
import React, { Component, PropTypes } from 'react'
import Slider from 'react-slick'
import { connect } from 'react-redux'
import assets from 'modules/assets'
import Image from 'components/Gallery/Image'
import photo from '../../../datas/photos/index.json'
import * as actions from 'actions'
import classNames from 'classnames'

class GallerySplashSection extends Component {
  constructor(props) {
    const SPLASH_ALBUM_NAMES = {
      '2016': 'camp-2016-splash',
      '2017': 'camp-2017-splash',
      '2018': 'camp-2018-splash',
      '2019': 'camp-2019-splash'
    }

    super(props)

    this.CAROUSEL_TIMER = 2000
    this.IMAGE_TRANSITION_TIME = 500
    this.state = {
      splashImages: photo[SPLASH_ALBUM_NAMES[this.props.year]].image,
      currentImageIndex: 0,
      isTransitioning: false,
      isHovered: false,
      windowHeight: 0,
      windowWidth: 0,
      text: '',
      timestamp: Date.now(),
      imageOffset: 0,
      transitionStart: -1
    }
    this.changeSplashImage = this.changeSplashImage.bind(this)
    this.tick = this.tick.bind(this)
  }
  tick() {
    let imageOffset = 0, transitionStart = this.state.transitionStart
    if (this.state.isTransitioning) {
      if (transitionStart == -1) transitionStart = this.state.timestamp
      const timeElapsed = this.state.timestamp - transitionStart
      imageOffset = timeElapsed / this.IMAGE_TRANSITION_TIME * this.state.windowHeight
      if (timeElapsed > this.IMAGE_TRANSITION_TIME) {
        this.transitionSplashImageDone()
        transitionStart = -1
        imageOffset = 0
      }
    }
    this.setState({
      timestamp: Date.now(),
      request: requestAnimationFrame(this.tick),
      transitionStart: transitionStart,
      imageOffset: imageOffset
    })
  }
  componentDidMount() {
    // In case we want to change automatically the splash image every X seconds.
    // this.imageChangeInterval = setInterval(this.changeSplashImage.bind(this), this.CAROUSEL_TIMER)
    this.setState({
      request: requestAnimationFrame(this.tick)
    })
    if (this.props.initialSwipe.active) {
      this.initialTimeout = setInterval(() => {
        this.changeSplashImage()
      }, 2000 + this.props.initialSwipe.delay)
    }

    if (this.state.windowWidth <= 640) {

    }
  }
  componentWillUnmount() {
    if (this.imageChangeInterval) clearInterval(this.imageChangeInterval)
    cancelAnimationFrame(this.state.request)
  }
  componentWillReceiveProps(nextProps) {
    this.setState({
      windowHeight: nextProps.windowHeight,
      windowWidth: nextProps.windowWidth,
      text: nextProps.text
    })
    if (nextProps.initialSwipe.active == false && this.props.initialSwipe.active) {
      clearInterval(this.initialTimeout)
      this.initialTimeout = null
    }
  }
  changeSplashImage() {
    this.setState({ isTransitioning: true })
  }
  transitionSplashImageDone() {
    const currIndex = this.state.currentImageIndex
    const noImages = this.state.splashImages.length
    this.setState({
      currentImageIndex: (currIndex + 1) % noImages,
      isTransitioning: false
    })
  }
  getCurrentSplashImage() {
    return this.state.splashImages[this.state.currentImageIndex]
  }
  getNextSplashImage() {
    const currIndex = this.state.currentImageIndex
    const noImages = this.state.splashImages.length
    return this.state.splashImages[(currIndex + 1) % noImages]
  }

  getImageOffset() {
    return this.state.imageOffset - this.state.windowHeight
  }

  onMouseOver() {
    this.setState({ isHovered: true })
    this.imageChangeInterval = setInterval(this.changeSplashImage.bind(this), this.CAROUSEL_TIMER)
    this.changeSplashImage()
  }

  onMouseOut(e) {
    this.setState({ isHovered: false })
    clearInterval(this.imageChangeInterval)
  }

  render() {
    let textClassnames = classNames('gallery-splash-item-year', {'hovered': this.state.isHovered})
    let divStyle = {
      'top': this.getImageOffset() + 'px'
    }
    let imgStyle = {
      'width': '100%',
      'display': 'block'
    }
    return (
      <div className="gallery-splash-item" onMouseEnter={this.onMouseOver.bind(this)} onMouseLeave={this.onMouseOut.bind(this)} onClick={this.props.onClick}>
        <div className='splash-image' style={divStyle}> <img src={this.getNextSplashImage().url} style={imgStyle}/> </div>
        <div className='splash-image' style={divStyle}> <img src={this.getCurrentSplashImage().url} style={imgStyle}/> </div>
        <div className={textClassnames}>{this.state.text}</div>
      </div>
    )
  }
}

GallerySplashSection.contextTypes = {
}
GallerySplashSection.propTypes = {
}
function mapStateToProps(state, ownProps) {
  return {
    location:ownProps.location
  }
}

export default connect(mapStateToProps)(GallerySplashSection)



// WEBPACK FOOTER //
// ./src/components/Gallery/GallerySplashSection.js